module.exports = __webpack_public_path__ + "static/media/three-dot-vertical.fc88e6a9.svg";